import pagesNames from "../../constants/pages-names";

const homePageData = {
    sectionOne: {
        title: "Embedding ESG At The Heart of Our Business And Operations",
        subtitle: "SAB has always played a part in driving economic growth and societal progress in the Kingdom. Today, we have an equally pivotal role to play in making a real and lasting difference to our environment, communities and people.",
        button: {
            text: "View Our ESG Strategy",
            path: pagesNames.starategy,
        }
    },
    chairmanSection: {
        description: "I am delighted to introduce SAB’s Sustainability Report for 2023. As a bank, we recognize the importance of our role in supporting the Kingdom’s sustainability efforts and the global energy transition. The synergy of these objectives contributes significantly to fostering sustainable development both within the Kingdom and beyond.",
        info: {
            name: "Ms. Lubna S. Olayan",
            position: "Chair",
        }
    },
    gallerySection: {
        rowOne: [
            {
                title: "2023 Highlights",
                subtitle: "2023 was a year of genuine progress for SAB. Throughout 2023, our ESG Office was pivotal in positioning SAB to oversee and execute numerous strategic ESG commitments and initiatives.",
                image: {
                    src: "2022-heighlight-card.jpg",
                    alt: "2022 Highlights background",
                },
                button: {
                    text: "Read more",
                    path: pagesNames.highlight,
                },
            },
            {
                title: "ESG report 2023",
                subtitle: "This report details the extent to which we have embedded ESG considerations in our corporate strategy, governance frameworks, and ethos",
                image: {
                    src: "our-lnaugural-esg-report-card.jpg",
                    alt: "Our Inaugural ESG Report background",
                },
                button: {
                    text: "Read more",
                    path: pagesNames.reports,
                },
            },
        ],
        rowTwo: [
            {
                title: "Transition to Net Zero",
                subtitle: "We at SAB grasp clearly that addressing climate change is an urgent and complex challenge that demands a fundamental transformation of the global economy.",
                image: {
                    src: "transition-to-net-zero-card.jpg",
                    alt: "mills over the sea background",
                },
                button: {
                    text: "Read more",
                    path: pagesNames.transition,
                },
            },
            {
                title: "Governance",
                subtitle: "SAB operates from a strong foundation of value-creating governance. We believe that a robust approach to corporate governance is key to the sustainability of the Bank",
                image: null,
                button: {
                    text: "Read more",
                    path: pagesNames.governance,
                },
            },
        ],
    },
    imageAndBoxSection: {
        image: {
            src: "",
            alt: "a man setting on a chair and looking at his couputer",
        },
        title: "SAB’s Materiality Determination Process",
        subtitle: "To determine our material matters, we followed a robust process of analysis and stakeholder engagement that incorporated both quantitative and qualitative elements.",
        button: {
            text: "View our Material Matters",
            path: pagesNames.materials,
        }
    },
    gridSection: {
        flexOne: [
            {
                title: "Energy and Emissions",
                path: pagesNames.emissions,
                image: {
                    name: "solar-panels.jpg",
                    alt: "Skyscrapers in front of the sea",
                },
                type: "image",

            },
            {
                title: "Sustainable Products and Services",
                path: pagesNames.sustainableFinancing,
                image: {
                    name: "clouds.mp4",
                    alt: "Sky and clounds",
                },
                type: "video",
            }
        ],
        boxOne: {
            description: "In pursuing the objectives outlines in Vision 2030, SAB also contributes to achieving many of the UNSDGs.",
            button: {
                text: "View Vision 2030 and UNSDGs",
                discription: "View or vidion in 2030 and UNSDGs",
                path: pagesNames.vision,
            }
        },
        flexTwo: [
            {
                title: "Project Future: SAB’s new smart office",
                subtitle: "Extending environmental sustainability in our operations has included refashioning our business premises for the sustainability transition",
                button: {
                    text: "Read more",
                    path: pagesNames.transition,
                },
                image: {
                    name: "project-future-card.jpg",
                    alt: "Project future background",
                },
            },
            {
                title: "Social Impact",
                subtitle: "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
                button: {
                    text: "Read more",
                    path: pagesNames.social,
                },
                image: {
                    name: "social-imact.jpg",
                    alt: "Social Impact background",
                },
            },
            {
                title: "Overarching Goal",
                subtitle: "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
                button: {
                    text: "Read more",
                    path: pagesNames.governance,
                },
                image: {
                    name: "overarching-card.jpg",
                    alt: "A picture of a cat sitting on a windowsill",
                },
            },
        ]
    }
}

export default homePageData;